import { render } from "./UploadEnquiry.vue?vue&type=template&id=5809b416"
import script from "./UploadEnquiry.vue?vue&type=script&lang=js"
export * from "./UploadEnquiry.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__